// extracted by mini-css-extract-plugin
export default {"root":"weekdays-grid_root__dYHiy","item":"weekdays-grid_item__YGsHJ","holiday":"weekdays-grid_holiday__uS8Zz","placeHolderShimmer":"weekdays-grid_placeHolderShimmer__YI8s8"};